import { createStepsStore } from "@/src/stores/createStepsStore";

export const useStepsStore = createStepsStore([
  "Basic details",
  "Location & Pricing",
  "Specification",
  "Amenities",
  "Summary",
] as const);
